import useUserRoleList from 'api/users/useUserRoleList/useUserRoleList';
import UserRolesModal from 'components/private/Modals/users/UserRolesModal/UserRolesModal';
import ApiPaginateTable from 'components/shared/Table/ApiPaginateTable';
import { permissions } from 'hooks/permissions/permissions';
import { usePermissions } from 'hooks/permissions/usePermissions';
import useUserRoleListTableColumns from 'hooks/users/useUserRoleListTableColumns';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

import PageSpinner from '../../components/shared/pageSpinner/PageSpinner';

const UserRoleList = () => {
  const { userGuid } = useParams();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState('100');
  const [selectedRows, setSelectedRows] = useState([]);

  const [activeModal, setActiveModal] = useState(null);

  const { getUserRoleList, loading, pageRef, roleList } = useUserRoleList();
  const tableRef = useRef(null);
  const { can } = usePermissions();

  const canEditRoles = can(
    permissions.general.categories.globalSettings.usersManagement.users
      .rolesEdit,
  );

  useEffect(() => {
    if (!userGuid) return;
    getUserRoleList({ Guid: userGuid, Page: 1, Count: pageSize }, () => {
      setPage(1);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userGuid]);

  const closeModal = useCallback(() => setActiveModal(null), []);

  const [columnsData] = useUserRoleListTableColumns({
    apiRef: tableRef,
  });

  const fetchRoles = useCallback(() => {
    getUserRoleList({ Guid: userGuid, Page: page, Count: pageSize }, () => {
      setPage(page);
    });
  }, [getUserRoleList, userGuid, pageSize, page]);

  return (
    <>
      <div>{pageRef.refTitle}</div>
      {Object.keys(roleList).length !== 0 ? (
        <ApiPaginateTable
          columns={columnsData}
          rowsData={roleList[page]}
          rows={roleList[page]}
          pageSize={pageSize}
          isDeletable={false}
          isLoading={loading}
          addLable={canEditRoles ? 'تغییر نقش' : undefined}
          onAddClick={
            canEditRoles ? () => setActiveModal('editRole') : undefined
          }
          setPageSize={val => setPageSize(val)}
          apiRef={tableRef}
          onPageChange={p => fetchRoles(p)}
          page={page}
          disableSelection
          countPages={
            pageRef?.totalCount ? Math.ceil(pageRef.totalCount / pageSize) : 1
          }
          setSelectedRows={rows => setSelectedRows(rows)}
          selectedRows={selectedRows}
        />
      ) : (
        <PageSpinner loading />
      )}

      {canEditRoles ? (
        <UserRolesModal
          open={activeModal === 'editRole'}
          editLoading={loading}
          handleClose={closeModal}
          userGuid={userGuid}
          onAssignRoleSuccess={fetchRoles}
        />
      ) : null}
    </>
  );
};

export default UserRoleList;
